import Header from './components/header.js';
import NavBar from './components/navbar.js';

function HeaderContainer(props) {
  return (
    <header className="site-header" /*agregar clase navbar-sticky para fijar navbar durante scroll*/>
      <Header
        NotificationsQty={props.NotificationsQty}
        getNotifications={props.getNotifications}
        NotificationsMsg={props.NotificationsMsg}
        WishlistItems={props.WishlistItems}
        cartItems={props.cartItems}
        deleteCartItem={props.deleteCartItem}
        username={props.username}
        loggedInData={props.loggedInData}
        handleLogout={props.handleLogout}
      />
      <NavBar />
    </header>
  );
}

export default HeaderContainer;
